import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { schoolIdAtom, schoolResponseAtom } from './school.atoms'
import { useMemo } from 'react'
import { UpdateSchoolSearchable } from 'shared/api/resources'
import { doAdminMutation } from 'infrastructure/api'
import { reinstateSchools, updateSchoolInformation } from 'shared/api/mutations'
import { SchoolInformationRequest } from 'infrastructure/api'

export function useSchoolResource(schoolId?: string | number) {
  const id = Number(schoolId)
  useSetAtom(schoolIdAtom)(id)
  const [atomData, reFetchSchool] = useAtom(schoolResponseAtom)

  return useMemo(() => {
    return {
      data: atomData,
      reFetchSchool,
      updateSchoolSearchable: async () => {
        if (!id) return
        await doAdminMutation(UpdateSchoolSearchable, { school_id: id })
        reFetchSchool()
      },
      updateSchoolInformation: async (params: SchoolInformationRequest) => {
        if (!id) return
        await updateSchoolInformation(id, params)
        reFetchSchool()
      },
      reinstate: async () => {
        await reinstateSchools({ school_ids: [id], reinstate_users: true })
        reFetchSchool()
      },
    }
  }, [id, atomData, reFetchSchool])
}
